<div class="canvas-container" id="threeCanvas">
    <div *ngIf="isLoading" class="loader-overlay">
        <mat-spinner diameter="60"></mat-spinner>
    </div>
    <canvas #main_canvas class="main-canvas" (mousedown)="$event.preventDefault()"> </canvas>
    <!-- To show warning message if screen size is less than 9 inch -->
    <div class="mobile-warning-overlay" *ngIf="!isSmallerScreen && !isAdminRoute">
        <div class="warning-card">
            <mat-icon class="warning-icon">warning</mat-icon>
            <h2>Mobile Not<br />Supported</h2>
            <p [innerHTML]="'designer.mobileWarningMessage.message' | translate"></p>
            <app-button variant="hero" (click)="closeWarning()">Go To Home</app-button>
        </div>
    </div>
    <!-- END -->
    <div *ngIf="!isViewMode && isNotFromProductDetail">
        <div id="selectionBox"></div>
    </div>
    <div
        class="mini-canvas"
        [tourAnchor]="DesignerTourSteps.shapeSelector.anchorId!"
        *ngIf="!isViewMode && isNotFromProductDetail"
        (mousedown)="$event.preventDefault()"
    >
        <shape-selector #shapeSelector></shape-selector>
    </div>
    <compass-cube class="compass" [tourAnchor]="DesignerTourSteps.compass.anchorId!"></compass-cube>
    <div class="capture-btn-container" *ngIf="isViewMode && structureData?.status === structureStatus.Published">
        <app-button
            variant="hero"
            buttonClass="explore-btn"
            (click)="!isCaptureImageLoaded && captureImage()"
            [disabled]="isDisabledCaptureBtn || isCaptureImageLoaded"
        >
            <ng-container *ngIf="!isCaptureImageLoaded; else loading"> Capture </ng-container>
            <ng-template #loading>
                <mat-progress-spinner diameter="20" mode="indeterminate" color="accent"> </mat-progress-spinner>
            </ng-template>
        </app-button>

        <app-button
            variant="hero"
            *ngIf="!isGlb"
            buttonClass="explore-btn"
            (click)="!isDisabledCapture360Btn && captureScene()"
            [disabled]="isDisabledCapture360Btn"
        >
            Capture 360
        </app-button>
    </div>
    <div class="zoom-actions" *ngIf="!isViewMode">
        <div
            *ngIf="isNotFromProductDetail"
            matTooltip="{{ 'designer.tooltip.copy' | translate }}"
            [tourAnchor]="DesignerTourSteps.copy.anchorId!"
        >
            <div
                class="copy-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="!selectedMeshes.length || copyPasteService.copiedMeshes.length"
                (click)="!isTourStepActive && clickCopyIcon()"
            >
                <mat-icon>content_copy</mat-icon>
            </div>
        </div>
        <div
            *ngIf="isNotFromProductDetail"
            matTooltip="{{ 'designer.tooltip.paste' | translate }}"
            [tourAnchor]="DesignerTourSteps.paste.anchorId!"
        >
            <div
                class="paste-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="!copyPasteService.copiedMeshes.length"
                (click)="!isTourStepActive && clickPasteIcon()"
            >
                <mat-icon>content_paste</mat-icon>
            </div>
        </div>
        <div
            *ngIf="isNotFromProductDetail"
            [tourAnchor]="DesignerTourSteps.duplicate.anchorId!"
            matTooltip="{{ 'designer.tooltip.duplicate' | translate }}"
        >
            <div
                class="duplicate-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="!selectedMeshes.length || copyPasteService.copiedMeshes.length"
                (click)="!isTourStepActive && clickDuplicateIcon()"
            >
                <mat-icon>library_add</mat-icon>
            </div>
        </div>
        <div
            *ngIf="isNotFromProductDetail"
            matTooltip="{{ 'designer.tooltip.undo' | translate }}"
            [tourAnchor]="DesignerTourSteps.undo.anchorId!"
        >
            <div
                class="undo-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="copyPasteService.copiedMeshes.length || !canUndo"
                (click)="!isTourStepActive && clickUndoIcon()"
            >
                <mat-icon>undo</mat-icon>
            </div>
        </div>
        <div
            *ngIf="isNotFromProductDetail"
            matTooltip="{{ 'designer.tooltip.redo' | translate }}"
            [tourAnchor]="DesignerTourSteps.redo.anchorId!"
        >
            <div
                class="redo-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="copyPasteService.copiedMeshes.length || !canRedo"
                (click)="!isTourStepActive && clickRedoIcon()"
            >
                <mat-icon>redo</mat-icon>
            </div>
        </div>
        <div
            *ngIf="isNotFromProductDetail"
            matTooltip="{{ 'designer.tooltip.delete' | translate }}"
            [tourAnchor]="DesignerTourSteps.deleteShape.anchorId!"
        >
            <div
                class="delete-container"
                [class.active-tour]="isTourStepActive"
                [class.disabled]="!selectedMeshes.length"
                (click)="!isTourStepActive && clickDeleteIcon()"
            >
                <mat-icon>delete</mat-icon>
            </div>
        </div>
        <div matTooltip="{{ 'designer.tooltip.zoomIn' | translate }}">
            <div
                class="zoom-in-container"
                [class.active-tour]="isTourStepActive"
                [tourAnchor]="DesignerTourSteps.zoomIn.anchorId!"
                (click)="!isTourStepActive && zoom(zoomConfig.zoomIn)"
            >
                <mat-icon>zoom_in</mat-icon>
            </div>
        </div>
        <div matTooltip="{{ 'designer.tooltip.zoomOut' | translate }}">
            <div
                class="zoom-out-container"
                [class.active-tour]="isTourStepActive"
                [tourAnchor]="DesignerTourSteps.zoomOut.anchorId!"
                (click)="!isTourStepActive && zoom(zoomConfig.zoomOut)"
            >
                <mat-icon>zoom_out</mat-icon>
            </div>
        </div>
    </div>
    <div class="drawer-container" *ngIf="!isViewMode && isNotFromProductDetail" (click)="$event.stopPropagation()">
        <action-button-container
            [isEditMode]="isEditMode"
            [isEditted]="isEditted"
            (resetIsEditted)="resetIsEditted($event)"
            (loadStructureId)="getSelectedId($event)"
            [structureData]="structureData"
            [autoCaptureCanvasFunction]="autoCaptureCanvas.bind(this)"
            (showSpinner)="showSpinner($event)"
            (openOnBoardingDialog)="openOnBoardingDialog()"
            [loadStructure]="loadStructure.bind(this)"
        >
        </action-button-container>
    </div>
    <div class="back-button" (click)="redirectPage()" *ngIf="!isViewMode && showBackButton">
        <mat-icon class="icon">arrow_back</mat-icon>
    </div>

    <div *ngIf="!isViewMode && !isNotFromProductDetail">
        <div fxLayout="row" fxLayoutAlign="center center">
            <h1 class="heading">{{ "Product3DviewinDesigner.countInformation" | translate }}</h1>
        </div>
        <div class="info-line">
            <b>P</b>= Plane, <b>C</b> = Curved, <b>HP</b> = Half-Plane, <b>N</b> = Node, <b>H</b> = Hole,
        </div>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "Product3DviewinDesigner.name" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <!-- Combination Column -->
                <ng-container matColumnDef="facePattern">
                    <th mat-header-cell *matHeaderCellDef>{{ "Product3DviewinDesigner.face-Pattern" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.facePattern }}</td>
                </ng-container>

                <!-- Count Column -->
                <ng-container matColumnDef="count">
                    <th mat-header-cell *matHeaderCellDef>{{ "Product3DviewinDesigner.count" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.count }}</td>
                </ng-container>

                <div *ngIf="isLoadingShape">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>

                <ng-container matColumnDef="shape">
                    <th mat-header-cell *matHeaderCellDef>{{ "Product3DviewinDesigner.shape" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <canvas #shape_canvas class="shape-canvas" [attr.data-index]="i"></canvas>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="highlightShape(row.uuid)"
                    [class.highlight-row]="row.uuid === selectedUuid"
                ></tr>
            </table>
        </div>
    </div>
</div>
